module.exports = __webpack_public_path__ + "img/logo-gxrlzy.9015cf80.png";